
























import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';

@Component({})
export default class PendingVerification extends Vue {
    private loginUrl: string = '';

    public mounted() {
        this.loginUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
    }
}
